:host {
  display: block;
}

.sample-image-blur {
  filter: blur(4px);
}
